import React from "react";
import { ListBulletIcon } from "./Icon";
import AnalyticsManager from "../utils/AnalyticsManager";
import styles from "./RecentReportsButton.module.css";

interface RecentReportsButtonProps {
  onClick: () => void;
  isHidden?: boolean;
  isSidebarOpen?: boolean;
  isActive?: boolean;
}

const RecentReportsButton: React.FC<RecentReportsButtonProps> = ({
  onClick,
  isHidden = false,
  isSidebarOpen = false,
  isActive = false
}) => {
  const buttonClasses = [
    styles["recent-reports-button"],
    isSidebarOpen ? styles["sidebar-open"] : "",
    isActive ? styles.active : "",
    isHidden ? styles.hidden : ""
  ].filter(Boolean).join(" ");

  return (
    <button
      onClick={() => {
        const analytics = AnalyticsManager.getInstance();
        analytics.trackEvent('recent_reports_button_click', {
          action: isActive ? 'close' : 'open',
          event_category: 'engagement',
        });
        onClick();
      }}
      className={buttonClasses}
      aria-label="Recent Reports"
    >
      <ListBulletIcon className={styles["recent-reports-icon"]} />
    </button>
  );
};

export default RecentReportsButton;